import { render, staticRenderFns } from "./NewSchoolYear.vue?vue&type=template&id=280bf38b"
import script from "./NewSchoolYear.vue?vue&type=script&lang=js"
export * from "./NewSchoolYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports